import { useMemo, useRef, useState } from 'react';
import { useQuery } from 'data-fetching-client';
import { GET_ROLLOUT_PRODUCT_UPDATES } from '../queries';
import useUpdatePUTableCache from './useUpdatePUTableCache';
const LIMIT = 50;
const useFetchAllPU = paramsForGetRolloutProductUpdates => {
  const tempAllProductUpdates = useRef([]);
  const {
    addToCache
  } = useUpdatePUTableCache();
  const [offset, setOffset] = useState(0);
  const [allProductUpdates, setAllProductUpdates] = useState([]);
  const variables = useMemo(() => Object.assign({}, paramsForGetRolloutProductUpdates, {
    limit: LIMIT,
    offset
  }), [offset, paramsForGetRolloutProductUpdates]);
  const {
    loading: isGetProductUpdateLoading,
    error: getAllPUError
  } = useQuery(GET_ROLLOUT_PRODUCT_UPDATES, {
    variables,
    onCompleted: ({
      rolloutProductUpdates: {
        rolloutProductUpdates,
        totalCount
      }
    }) => {
      tempAllProductUpdates.current = tempAllProductUpdates.current.concat(rolloutProductUpdates);
      addToCache(rolloutProductUpdates);
      if (offset + LIMIT >= totalCount) {
        // all product updates are fetched
        setAllProductUpdates([...tempAllProductUpdates.current]);
      } else {
        // fetch next batch
        setOffset(offset + LIMIT);
      }
    }
  });
  return {
    allProductUpdates,
    isGetProductUpdateLoading,
    getAllPUError
  };
};
export default useFetchAllPU;